import React from 'react';
import { SeoHead } from './components/SeoHead';
import { LanguageProvider } from './contexts/LanguageContext';
import { Home } from './pages/Home';
interface AppProps {
  defaultLanguage?: 'en' | 'es';
  showTrustBar?: boolean;
  showProcessSteps?: boolean;
}
export function App({
  defaultLanguage = 'en',
  showTrustBar = true,
  showProcessSteps = true
}: AppProps) {
  return <LanguageProvider initialLang={defaultLanguage} data-id="element-0" data-mp="2rkno0jqitmui">
      <SeoHead data-id="element-1" data-mp="2rlf6csv3xo2u" />
      <Home showTrustBar={showTrustBar} showProcessSteps={showProcessSteps} data-id="element-2" data-mp="2rit1x23ijoou" />
    </LanguageProvider>;
}